import { useEffect } from "react";
import { useAuthStatus } from "context/OAuth/AuthContext";

const Login = () => {
    const { login } = useAuthStatus();

    useEffect(() => {
        login(); 
    }, [login]);

    return null;
};

export default Login;
